module.exports = __webpack_public_path__ + "static/media/news3.3ee5bdc7.png";